/*
====================================================================
                   Clase NotificacionEntity
====================================================================
Esta clase representa una entidad de notificación que encapsula la 
información necesaria para mostrar una notificación en la aplicación.

- Almacena el título, descripción, tipo y duración de la notificación.
- Los tipos de notificación pueden ser: verde, rojo, amarillo o azul.
- La duración de la notificación se define en segundos.

====================================================================
*/

// ------------------------------------------------------------------
//                       DEFINICIÓN DE LA CLASE
// ------------------------------------------------------------------
/**
 * Clase que representa una entidad de notificación.
 * 
 * Esta clase encapsula los datos necesarios para mostrar una notificación
 * en la interfaz de usuario, incluyendo el título, la descripción, el tipo
 * de notificación y su duración.
 */
class NotificacionEntity {
  /**
   * Constructor de la clase NotificacionEntity.
   * 
   * @param {string} titulo - El título de la notificación.
   * @param {string} descripcion - La descripción detallada de la notificación.
   * @param {string} tipo - El tipo de notificación, que puede ser "verde", "rojo", "amarillo" o "azul".
   * @param {number} duracion - La duración de la notificación en segundos.
   */
  constructor(titulo = "", descripcion = "", tipo = "verde", duracion = 10) {
    this.titulo = titulo;
    this.descripcion = descripcion;
    this.tipo = tipo;
    this.duracion = duracion;
  }
}

// ------------------------------------------------------------------
//                            EXPORTS
// ------------------------------------------------------------------
// Exportación de la clase para su uso en otros módulos de la aplicación.

export default NotificacionEntity;
